<template>
  <v-card>
    <v-toolbar card dense color="transparent">
      <v-toolbar-title>
        <h4>{{ $t('dashboard.today_packing') }}</h4>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>more_vert</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>
        <v-data-table :headers="headers" :items="projects" hide-actions class="elevation-0">
          <template slot="items" slot-scope="props">
            <td>
              <v-avatar size="36px" color="teal">
                <span class="white--text headline">{{ props.item.username }}</span>
              </v-avatar>
            </td>
            <td>{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.deadline }}</td>
            <td class="text-xs-left">
              <v-progress-linear :value="props.item.progress" height="5" :color="props.item.color"></v-progress-linear>
            </td>
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
// import { Projects } from '@/api/project';

import DashboardService from "@/services/DashboardService";

export default {
  data() {
    return {
      headers: [
        {
          text: "",
          align: "center",
          sortable: false,
          value: "avatar"
        },
        {
          text: "Name",
          align: "left",

          sortable: false,
          value: "name"
        },
        { text: "Num of Boxs", value: "deadline" },
        { text: "Progress", value: "progress" }
      ],
      projects: []
    };
  },
  computed: {
    //   projects() {
    //     return [
    //       {
    //         username: "Dessie",
    //         avatar:
    //           "https://s3.amazonaws.com/uifaces/faces/twitter/ludwiczakpawel/128.jpg",
    //         name: "Template PSD",
    //         deadline: "2 days later",
    //         progress: 90,
    //         color: "pink"
    //       },
    //       {
    //         username: "Jakayla",
    //         avatar:
    //           "https://s3.amazonaws.com/uifaces/faces/twitter/suprb/128.jpg",
    //         name: "Logo Design",
    //         deadline: "1 weeks later",
    //         progress: 70,
    //         color: "success"
    //       },
    //       {
    //         username: "Ludwiczakpawel",
    //         avatar:
    //           "https://s3.amazonaws.com/uifaces/faces/twitter/ludwiczakpawel/128.jpg",
    //         name: "REST API",
    //         deadline: "1 Month later",
    //         progress: 50,
    //         color: "info"
    //       },
    //       {
    //         username: "Damenleeturks",
    //         avatar:
    //           "https://s3.amazonaws.com/uifaces/faces/twitter/damenleeturks/128.jpg",
    //         name: "API Unit Test",
    //         deadline: "2 Month later",
    //         progress: 30,
    //         color: "teal"
    //       },
    //       {
    //         username: "Caspergrl",
    //         avatar:
    //           "https://s3.amazonaws.com/uifaces/faces/twitter/caspergrl/128.jpg",
    //         name: "Project Deploy",
    //         deadline: "half year later",
    //         progress: 15,
    //         color: "grey"
    //       }
    //     ];
    //   }
  },
  methods: {
    async fetchUserPackingData() {
      await DashboardService.getPackByUsers().then(res => {
        if (res.success) {
          let allPacks = res.data.reduce((sum, number) => {
            return sum + number.boxes;
          }, 0);

          let packersfetch = [];
          res.data.forEach(function(packer) {
            packersfetch.push({
              username: packer.packer_name[0],
              name: packer.packer_name,
              deadline: packer.boxes,
              progress: (packer.boxes / allPacks) * 100
            });
          });

          this.projects = packersfetch;
          setTimeout(() => {
            this.fetchUserPackingData();
            }, 60000);
        }
      });
    }
  },
  created() {
    this.fetchUserPackingData();
  }
};
</script>
